import { AuthService } from './AuthService';
import { DomainService } from "./DomainService";
const baseUrl = DomainService.GetBaseUrl() + "CommonDropDown/";

const getSortSearchKeyWords = async () => {
    const res = await fetch(baseUrl + "GetSortSearchKeyWords", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getKeyWordWithin = async () => {
    const res = await fetch(baseUrl + "GetKeyWordWithin", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getResumeLastUpdatedInMonths = async () => {
    const res = await fetch(baseUrl + "GetResumeLastUpdatedInMonths", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getAnyEmployeeType = async () => {
    const res = await fetch(baseUrl + "GetAnyEmployeeType", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getKeywordsList = async (inputText) => {
    if (inputText === "" || inputText === undefined || inputText === null) {
        inputText = "";
    }
    const res = await fetch(baseUrl + "GetKeywordsList?inputText=" + inputText, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getSearchAnyKeywords = async () => {
    const res = await fetch(baseUrl + "GetSearchAnyKeywords", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getEmployeeSearchCondition = async () => {
    const res = await fetch(baseUrl + "GetEmployeeSearchCondition", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getCountry = async () => {
    const res = await fetch(baseUrl + "GetCountry", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getIndustry = async () => {
    const res = await fetch(baseUrl + "GetIndustry", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getFunctionalAreas = async () => {
    const res = await fetch(baseUrl + "GetFunctionalAreas", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getFunctionalAreasSpecializaton = async (functionalAreaId) => {
    const res = await fetch(baseUrl + "GetFunctionalSpecialization?functionalAreaIds=" + functionalAreaId, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getInstitutes = async () => {
    const res = await fetch(baseUrl + "GetInstitutes", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getCountryCode = async () => {
    const res = await fetch(baseUrl + "GetCountryCode", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getQualification = async () => {
    const res = await fetch(baseUrl + "GetQualification", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getQualificationSpecializationByID = async (qualificationID) => {
    const res = await fetch(baseUrl + "GetQualificationSpecialization?qualificationIDs=" + qualificationID, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getCurrentLocation = async () => {
    const res = await fetch(baseUrl + "GetCurrentLocation", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getAssignments = async () => {
    const res = await fetch(baseUrl + "GetAssignments?UserID=" + AuthService.getCurrentUser().userId, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getJobPostingsById = async (assignmentId) => {
    const res = await fetch(baseUrl + "GetJobPostings?UserID=" + AuthService.getCurrentUser().userId + "&assignmentID=" + assignmentId, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getFolders = async () => {
    const res = await fetch(baseUrl + "GetMyFolders?UserID=" + AuthService.getCurrentUser().userId, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getClientsByUserID = async () => {
    const res = await fetch(baseUrl + "GetClientsByUserID?UserID=" + AuthService.getCurrentUser().userId, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    let data = await res.json();
    return data;
}
const getAssignmentByUserID = async () => {
    const res = await fetch(baseUrl + "GetAssignmentByUserID?UserID=" + AuthService.getCurrentUser().referenceID, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    let data = await res.json();
    return data;
}
const getSourceByLocation = async (locationID) => {
    const res = await fetch(baseUrl + "GetSource?locationID=" + locationID, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getCoOrdinatorByUserID = async () => {
    const res = await fetch(baseUrl + "GetCoOrdinatorsByUserID?UserID=" + AuthService.getCurrentUser().userId, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    let data = await res.json();
    return data;
}
const get_NoticePeriod_DropdownList = async () => {
    const res = await fetch(baseUrl + "GetNoticePeriodList", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}
const get_Language_DropdownList = async () => {
    const res = await fetch(baseUrl + "GetLanguageDropDown", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}
const get_Lang_Proficiency_DropdownList = async () => {
    const res = await fetch(baseUrl + "GetLangProficiencyDropDown", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}
const GetReligionDropdown = async () => {
    const res = await fetch(baseUrl + "GetReligionDropdown", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}
const GetNationalityDropDown = async () => {
    const res = await fetch(baseUrl + "GetNationalityDropDown", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}
const getFunctionalAreaSpecializationDropDown = async () => {
    const res = await fetch(baseUrl + "GetFunctionalAreaSpecializationDropDown", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}
const getCurrencyDropdown = async () => {
    const res = await fetch(baseUrl + "GetCurrencyDropdown", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}
const get_KeyWordLogic_BuilderFor_KeySkill = async (keySkill,type) => {
    const res = await fetch(baseUrl + "GetKeyWordLogicBuilderForKeySkill?keySkillKeyWord=" + keySkill+"&logicType="+type, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const CheckIsEmailOrMobileOrPpExist = async (emailOrMobileOrPP, type,candidateID) => {
    const res = await fetch(baseUrl + "CheckIsEmailOrMobileOrPpExist?emailOrMobileOrPP=" + emailOrMobileOrPP + "&type=" + type+"&candidateID="+candidateID, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    });
    const data = await res.json();
    return data;
}
const getEmailTemplate = async () => {
    const res = await fetch(baseUrl + "GetEmailTemplates?UserID=" + AuthService.getCurrentUser().userId, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getTemplateBody = async (code) => {
    const res = await fetch(baseUrl + "GetTemplateBody?Code=" + code+"&userID="+AuthService.getCurrentUser().userId, {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const getDocTypes = async () => {
    const res = await fetch(baseUrl + "GetDocTypes", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });
    const data = await res.json();
    return data;
}

const getInterviewTypes = async () => {
    const res = await fetch(baseUrl + "GetInterviewTypes", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });
    const data = await res.json();
    return data;
}
const getRejectionStatus = async () => {
    const res = await fetch(baseUrl + "GetRejectionStatus", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
const GetLanguage = async () => {
    const res = await fetch(baseUrl + "GetLanguage", {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    });
    const data = await res.json();
    return data;
}
export const CommonDropDownService = {
    get_NoticePeriod_DropdownList,
    get_Language_DropdownList,
    get_Lang_Proficiency_DropdownList,
    GetReligionDropdown,
    getFunctionalAreaSpecializationDropDown,
    getKeywordsList,
    getSortSearchKeyWords,
    getKeyWordWithin,
    getResumeLastUpdatedInMonths,
    getAnyEmployeeType,
    getSearchAnyKeywords,
    getEmployeeSearchCondition,
    getCountry,
    getIndustry,
    getFunctionalAreas,
    getFunctionalAreasSpecializaton,
    getInstitutes,
    getQualification,
    getQualificationSpecializationByID,
    getCurrentLocation,
    getAssignments,
    getJobPostingsById,
    getFolders,
    getAssignmentByUserID,
    getClientsByUserID,
    getSourceByLocation,
    getCoOrdinatorByUserID,
    GetNationalityDropDown,
    getCurrencyDropdown,
    CheckIsEmailOrMobileOrPpExist,
    getEmailTemplate,
    getTemplateBody,
    getCountryCode,
    getDocTypes,
    getInterviewTypes,
    getRejectionStatus,
    get_KeyWordLogic_BuilderFor_KeySkill,
    GetLanguage
} 